<dx-popup
  [(visible)]="isVisible"
  [showTitle]="false"
  [showCloseButton]="false"
  [hideOnOutsideClick]="false"
  [dragEnabled]="false"
  [width]="'90%'"
  [maxWidth]="1000"
  [height]="'auto'"
  [maxHeight]="'95vh'"
>
  <div *dxTemplate="let data of 'content'">
    <div class="tenant-video-content">
      <div class="tenant-video-header">
        <h2>
          {{ 'TENANT-VIDEO.OVERVIEW.TITLE' | translate }}
        </h2>

        <p>
          {{ 'TENANT-VIDEO.OVERVIEW.DESCRIPTION' | translate }}
        </p>
      </div>

      <app-video-player
        *ngIf="tenantVideo"
        #videoPlayer
        [videoUrl]="tenantVideo.file.fileUrl"
        [hlsUrl]="tenantVideo.file.hlsUrl"
        [allowVideoFastForward]="false"
        [videoProgressSeconds]="videoProgressSeconds"
        [requireFullscreen]="false"
        [hideVideo]="false"
        (progressChanged)="onVideoProgressChanged($event)"
        (videoEnded)="onVideoEnded()"
      ></app-video-player>

      <div *ngIf="errorMessage" class="video-error">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</dx-popup>